/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useMemo, useState } from 'react';
import logo from '../assets/Logo.png';

const ops = () => {
	window.open("#");
}

const discord = () => {
	window.open("https://discord.com/invite/tknBv7Xwuj");
}

const homeLink = () => {
	window.open("#");
}


const Footer = () => {

	return (
		<footer class="footer">
			<div class="container">
				<img src={logo}/>
				<p>&copy; 2024 SV.LUXURY</p>
				<p><a href="#">Privacy Policy</a> | <a href="#">Terms & Conditions</a></p>
			</div>
		</footer>

	)

}
export default Footer;
